import { render, staticRenderFns } from "./InsuranceCertificateSkeleton.vue?vue&type=template&id=43a5510b&scoped=true"
import script from "./InsuranceCertificateSkeleton.vue?vue&type=script&lang=js"
export * from "./InsuranceCertificateSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCertificateSkeleton.vue?vue&type=style&index=0&id=43a5510b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a5510b",
  null
  
)

export default component.exports